module.exports = __webpack_public_path__ + "img/pintarest.sh.50866f3c.svg";